import FilterPopOver from "components/FilterPopOver";
import { CloseIcon, FilterIcon } from "components/icons";
import SelectMultipleTag from "components/SelectMultipleTag";

import useCorpGlobalFilter from "./useGlobalCorpFilter";
import { useTranslationContext } from "context/TranslationContext";

import { TGetCorpGlobalFilter } from "pages/Search/Corporation/Model/types";

interface FilterProps {
  filter?: Partial<TGetCorpGlobalFilter>;
  onFilter?: (filter: Partial<TGetCorpGlobalFilter>) => void;
}

const Filter = ({ filter, onFilter }: FilterProps) => {
  const { t } = useTranslationContext();
  const {
    openFilter,
    businessUnitTags,
    bupOptions,
    isEmptyFilter,
    onSubmitFilter,
    onResetFilter,
    onOpenFilter,
    onCloseFilter,
    setBusinessUnitTags,
    onCloseAndResetFilter,
  } = useCorpGlobalFilter({ filter, onFilter });

  return (
    <div className="relative">
      {isEmptyFilter ? (
        <button
          onClick={onOpenFilter}
          className="flex justify-center items-center rounded-md border border-gray-200 h-[2.64rem] w-[2.64rem] hover:shadow-[0px_0px_1px_1px_rgb(0,122,245,0.4)] hover:ring-primary-500"
        >
          <FilterIcon width={18} height={18} />
        </button>
      ) : (
        <div className="flex gap-2 items-center justify-between border border-primary-150 bg-primary-50 text-primary-500 px-3 h-[2.64rem] rounded-lg text-base">
          <button
            className="flex items-center justify-start gap-2"
            onClick={onOpenFilter}
          >
            <FilterIcon width={16} height={16} />
            {t("filter")}
          </button>
          <button
            className="border-l border-primary-150 flex items-center justify-center pl-1"
            onClick={onCloseAndResetFilter}
          >
            <CloseIcon width={15} height={15} />
          </button>
        </div>
      )}

      {openFilter && (
        <FilterPopOver
          onClose={onCloseFilter}
          title={t("filter")}
          onSubmitFilter={onSubmitFilter}
          onResetFilter={onResetFilter}
          submitButtonActive={true}
          hasValue={!isEmptyFilter}
          height="h-[calc(100vh-35rem)]"
        >
          <SelectMultipleTag
            withImage
            label={t("businessunit_membership")}
            options={bupOptions}
            placeHolder={t("choose_businessunit")}
            setValues={setBusinessUnitTags}
            values={businessUnitTags}
          />
        </FilterPopOver>
      )}
    </div>
  );
};

export default Filter;
